import logo from 'assets/logo2.png';
import { Button } from 'components/Elements';
import { Head } from 'components/Head';
import { useAuth } from 'lib/auth';
import { useNavigate } from 'react-router';
import { useTheme } from 'hooks/useTheme';

export const Landing = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { theme, background } = useTheme(); // Get gradient & background

  const handleStart = () => {
    if (user) {
      navigate('/app');
    } else {
      navigate('/auth/login');
    }
  };

  return (
    <>
      <Head title="Wire24" description="Administration" />
      <div
        className={`h-screen flex items-center justify-center ${theme} relative overflow-hidden`}
      >
        {/* Background Pattern (if set) */}
        <div className="absolute inset-0 pointer-events-none opacity-10">
          {background && (
            <img
              src={background}
              alt="Decorative Overlay"
              className="w-full h-full object-cover"
            />
          )}
        </div>

        {/* Main Content */}
        <div className="relative z-10 p-10 max-w-4xl mx-auto text-center">
          {/* Logo & Header */}
          <div className="flex flex-col items-center text-white mb-2">
            <img className="h-14 w-auto mb-1" src={logo} alt="Wire24" />
            <span className="text-xs">Administrator ©</span>
          </div>

          {/* CTA Button */}
          <div className="mt-3 mb-32 flex justify-center">
            <Button variant="darkGlass" onClick={handleStart}>
              {user ? `Welcome Back ${user?.firstName}` : 'Continue'}
            </Button>
          </div>

          {/* Legal & Disclaimer */}
          <div className="text-white text-sm mt-10 opacity-80 space-y-3">
            <p>
              <div className="mb-1">Authorized Access Only.</div>
              <span className="text-xs">
                This console is strictly intended for authorized administrators.
                Unauthorized access, use, or distribution is prohibited and will
                result in legal prosecution. All console activity is monitored
                and logged. By proceeding, you acknowledge and consent to this
                monitoring in accordance with Wire24{' '}
                <a
                  href="https://wire24.co/terms-of-service"
                  className="underline"
                >
                  Terms and conditions
                </a>{' '}
                and{' '}
                <a
                  href="https://wire24.co/privacy-policy"
                  className="underline"
                >
                  Privacy Policy
                </a>
                .
              </span>
            </p>
            <p className="text-xs">
              © {new Date().getFullYear()} Wire24 Inc. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
